import { render } from "./UpgradeKubernetesCluster.vue?vue&type=template&id=8054f36a&scoped=true"
import script from "./UpgradeKubernetesCluster.vue?vue&type=script&lang=js"
export * from "./UpgradeKubernetesCluster.vue?vue&type=script&lang=js"

import "./UpgradeKubernetesCluster.vue?vue&type=style&index=0&id=8054f36a&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder@2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8054f36a"]])

export default __exports__